export const SOFAR_PRIVACY_POLICY_URL =
  'https://www.sofarsounds.com/privacy_policy';
export const SOFAR_TERMS_AND_CONDITIONS_URL =
  'https://www.sofarsounds.com/terms_and_conditions';
export const SOFAR_MOBILE_TERMS_URL =
  'https://www.sofarsounds.com/mobile_terms_and_conditions';
export const PRIVATE_RELAY_HELP_URL =
  'https://help.sofarsounds.com/hc/en-us/articles/29137811036177-I-used-Hide-My-Email-with-Apple-will-I-still-get-emails-about-my-order';
export const NEW_HELP_REQUEST_URL =
  'https://help.sofarsounds.com/hc/en-us/requests/new';
export const ACCESSIBILITY_HELP_ARTICLE_URL =
  'https://help.sofarsounds.com/hc/en-us/articles/360005498218-Where-can-I-find-accessibility-information-for-a-show';
export const GIFT_CARD_FAQ_URL =
  'https://help.sofarsounds.com/hc/en-us/sections/41125788591633-Gift-Cards';
export const GIFT_CARD_TERMS_AND_CONDITIONS_URL =
  'https://www.sofarsounds.com/gift_card_terms_and_conditions';

export const VISA_US_OFFER_TERMS_URL =
  'https://www.sofarsounds.com/visaoffer/terms-and-conditions';
export const VISA_US_OFFER_DEBIT_TERMS_URL =
  'https://www.sofarsounds.com/visaoffer/debit-terms-and-conditions';
export const VISA_US_OFFER_CREDIT_TERMS_URL =
  'https://www.sofarsounds.com/visaoffer/credit-terms-and-conditions';
export const VISA_US_OFFER_FAQS_URL =
  'https://www.sofarsounds.com/visaoffer/debit-credit-faqs';
export const VISA_GLOBAL_OFFER_TERMS_URL =
  'https://www.sofarsounds.com/visaoffer/global-terms-and-conditions';
export const VISA_GLOBAL_OFFER_FAQS_URL =
  'https://www.sofarsounds.com/visaoffer/visadestinations-faqs';
